module.exports = __webpack_public_path__ + "static/media/money.be4432b0.png";